<template>
  <div id="app">
    <router-view :key="key"></router-view>
    <comFooter
      v-if="$route.meta.hasFooter !== false && renderFooter"
    ></comFooter>
  </div>
</template>

<script>
import {
  checkBrowserRunnable,
  isWxBrowser,
  isMobile,
  isIE
} from "@/utils/check";
import { mapState, mapMutations } from "vuex";
import comFooter from "@/components/common/Footer.vue";
export default {
  name: "App",
  data() {
    return {
      renderFooter: false
    };
  },
  methods: {
    ...mapMutations(["setEnv", "setUserInfo", "setProductList"])
  },
  computed: {
    ...mapState(["env"]),
    key() {
      return this.$route.path + Math.random();
    },
  },
  created() {
    
    checkBrowserRunnable();
    this.setEnv({ prop: "isMobile", flag: isMobile() });

    this.setEnv({ prop: "isWx", flag: isWxBrowser() });

    this.setEnv({ prop: "isIE", flag: isIE() });

    this.$nextTick(() => {
      setTimeout(() => {
        this.renderFooter = true;
      }, 2000);
    });
  },
  beforeMount() {
    if(this.env.isMobile) {
      require('lib-flexible') 
   }else {
     require('./utils/setRootVlalue')
   }
  },
  components: {
    comFooter
  }
};
</script>
<style lang="scss">
</style>
